(ns builder.builder.view
  (:require [builder.pages :as pages]
            [builder.builder.model :as model]
            [builder.sdc.posthog :as posthog]
            [stylo.core :refer [c]]
            [reagent.core :as r]
            [re-frame.core :as rf]
            #?(:cljs ["react"])))


(defn iframe-load-handler [e]
  #?(:cljs
     (let [iframe (.-target e)
           content-doc (.. iframe -contentWindow -document)]
       (letfn [(init-observer []
                 (let [panel (.querySelector content-doc ".flex.flex-col.flex-shrink-0.overflow-hidden:has(#download-json)")
                       target (.getElementById content-doc "download-json")]
                   (if (and panel target js/Intercom)
                     (doto (js/ResizeObserver.
                             (fn []
                               (let [rect (.getBoundingClientRect target)
                                     space-below (- js/window.innerHeight (.-bottom rect))
                                     padding (if (< space-below 140) 135 50)]
                                 (js/Intercom "update" #js {:vertical_padding padding}))))
                       (.observe panel))
                     (js/requestAnimationFrame init-observer))))]
              (init-observer)))))

(defn view []
  (let [q-id (rf/subscribe [::model/form-id])
        q-data (rf/subscribe [::model/questionnaire-data])
        aidbox-portal-token (rf/subscribe [::model/aidbox-portal-token])]
    (fn []
      [:div
       [:div {:class "h-12 bg-gradient-to-r from-indigo-700
 to-violet-700 via-violet-600 w-full flex justify-center items-center gap-2"}
        [:span {:class "text-base text-white text-lg"}
         "Unlock the full Formbox platform"]
        [:a {:href "https://aidbox.app/ui/portal"
             :target "_blank"
             :id "sign-up-button"
             :on-click (fn [_]
                         (rf/dispatch [::posthog/report-event {:event "box_sdc:public_builder:sign-up-button" :properties {}}]))
             :class [:text-white :hover:text-violet-700
                     :hover:bg-white "border-[1px]" :border-white :rounded
                     :py-1 :px-2]} "Explore Formbox"]]
       [:iframe {:style {:height "calc(100vh - 3rem)"
                         :width "100vw"}
                 :id "builder-frame"
                 :onLoad (fn [_]
                           (rf/dispatch [::model/sync-builder-config])
                           )
                 :src (cond-> "/ui/sdc#/forms/builder?f=555628811"
                        @q-id
                        (str "&form=" @q-id)
                        @q-data
                        (str "&q=" @q-data)
                        @aidbox-portal-token
                        (str "&token=" @aidbox-portal-token)
                        )}]])))


(pages/reg-page ::model/ctx view)
